export const GET_LOGIN_HISTORY = 'GET_LOGIN_HISTORY';
export const LOCATE_IPS = 'LOCATE_IPS';
export const DETECT_USER_AGENTS = 'DETECT_USER_AGENTS';